// managementServices.js

import apiClient from './apiClient';
export { fetchAnnouncements, fetchCommunications, fetchGuests, fetchDiaryEntries } from './commonServices';

export const fetchAttachments = async () => {
    const response = await apiClient.get('/attachments.php');
    return response.data;
};

export const fetchCollaborators = async () => {
    const response = await apiClient.get('/collaborators.php');
    return response.data;
};
